module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1500.386ad1e1.svg";